import { useState, useEffect } from "react";

export const useBanner = () => {
  const [bannerMessage, setBannerMessage] = useState("");
  const [bannerVisible, setBannerVisible] = useState(false);
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    if (bannerVisible) {
      const timer = setTimeout(() => setBannerVisible(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [bannerVisible]);

  const showBanner = (message: string, error: boolean = false) => {
    setBannerMessage(message);
    setIsError(error);
    setBannerVisible(true);
  };

  return { bannerMessage, bannerVisible, isError, showBanner };
};
